import {api} from '@/plugins/api';
import {SysDictData} from '@/types/api-beans';
import _ from 'lodash';

let TMP_TYPES: { [key: string]: Array<(data) => any> } = {};
const delayGet = _.debounce(() => {
  const requestTypes = {...TMP_TYPES};
  TMP_TYPES = {};
  api.system.dict.data.types.getByTypes.r(Object.keys(requestTypes)).then((data) => {
    Object.keys(requestTypes).forEach(type => {
      const items = data[type] ?? [];
      requestTypes[type].forEach(it => {
        it(items);
      });
    });
  });
}, 20);

export const get = (code: string): Promise<SysDictData[]> => {
  return new Promise(resolve => {
    if (TMP_TYPES[code]) {
      TMP_TYPES[code].push(resolve);
    } else {
      TMP_TYPES[code] = [resolve];
    }
    delayGet();
  });
};
